import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { VIEW_TYPE } from '../../../../../enums/ViewType';
import {useDispatch, useSelector} from 'react-redux';
import { GetUserTrafficDetails } from '../../../../../reduxToolkit/Traffic/TrafficApi';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import { errorMsg } from '../../../../../Apis/functions';
import { TRAFFIC_FINES_MODEL } from '../Model/Model';
import routes from "../../../../../Routes/routes";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
export const TrafficDetailsApp = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const location = useLocation();
    const { state } = location;

    const [userData, setUserData] = useState();
    // Stores traffic or fine details data
    // State to manage the selected date range (initialized from a predefined model)
    const [dateRange, setDateRange] = useState({ ...TRAFFIC_FINES_MODEL });
    // Stores the current view type (list, chart, etc.)
    const [view, setView] = useState(VIEW_TYPE.LIST.name);
    // Holds the total number of fines retrieved
    const [finesCount, setFinesCount] = useState(0);
    // Controls whether the fines details modal is open or closed
    const [detailsModal, setDetailsModal] = useState(false);
    // Stores the selected fine item ID or identifier
    const [itemSelected, setItemSelected] = useState('');
    let dispatch = useDispatch();
    const navigate = useNavigate();

    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentTypeSelect, setPaymentTypeSelect] = useState(null);
    const [showConfirmationPay, setShowConfirmationPay] = useState(false);
    const [modified, setModified] = useState(0);

    // Fetch user traffic details when the component is first mounted
    useEffect(() => {
        dispatch(GetUserTrafficDetails(id)).then(
            ({
                payload: {
                    data: { data, success, code },
                },
            }) => {
                if (success) {
                    setUserData(data);
                } else errorMsg(code);
            },
        );
    }, [modified]);

    const handleOnBack = () => {
        navigate(
            routes.traffic.list, {
                state: state
            });
    }

    /**
     * Function to display the modal to proceed with the fine payment.
     * @param value
     * @param option
     */
    const handleSetShowPaymentModal = (value, option) => {
        setDetailsModal(false);
        setShowPaymentModal(value);
        setPaymentTypeSelect(option);
    }

    return {
       dateRange,
        setDateRange,
        view,
        setView,
        t,
        finesCount,
        setFinesCount,
        setDetailsModal,
        detailsModal,
        itemSelected,
        setItemSelected,
        userData,
        handleOnBack,
        showPaymentModal,
        setShowPaymentModal: (value, option) => handleSetShowPaymentModal(value, option),
        paymentTypeSelect,
        showConfirmationPay, setShowConfirmationPay,
        modified, setModified
    };
};
